/// <reference path="BaseField.ts" />

namespace MACRAIL.Forms.Fields {

export class Buttonset extends BaseField {

    protected opts: ButtonsetOptions;

    constructor (element: string | JQuery, opts: ButtonsetOptions = {}) {
        super(element, opts);

        let self = this;
    }

    public setEnabled(enabled: boolean) {
        super.setEnabled(enabled);

        if (enabled) {
            this.element.find('label').removeClass('disabled');
            this.element.find('input').prop('disabled', false);
        } else {
            this.element.find('label').addClass('disabled');
            this.element.find('input').prop('disabled', true);
        }
    }

    public setValueEnabled(value: string, enabled: boolean) {
        let $label = this.element.find('input[value="' + value + '"]').parent();

        if (enabled) {
            $label
                .prop('disabled', false)
                .removeClass('disabled');
        } else {
            $label
                .prop('disabled', true)
                .addClass('disabled');
        }
    }

    public getValue() {
        return this.element.find('input:checked').val();
    }

    public setValue(newValue: any) {

        // Changing by triggering a click doesn't work when the field is disabled. Therefore temporarily re-enable.
        let wasDisabled = false;
        if (!this.isEnabled()) {
            wasDisabled = true;
            this.setEnabled(true);
        }

        if (newValue === undefined) {
            this.element
                .find('input:checked')
                .prop('checked', false)
                .parent()
                .removeClass('active');
        } else {
            this.element.find('[value="' + newValue + '"]').trigger('click');
        }

        if (wasDisabled) {
            this.setEnabled(false);
        }
    }
}

interface ButtonsetOptions extends FieldOptions {
}

}
